
$(document).ready(function($) {
	if(!window.isIos && window.innerWidth > 992){
		$.fn.headerSmallParallax = function() {
			var scrolledY = $(window).scrollTop();
			var scrollBottom = $(window).scrollTop() + $(window).height();
			var $self = $(this);
			var height = $self.height();
			var value = -scrolledY*01;
			
			if($(window).scrollTop() + $(window).height() < $(document).height() - 100) {
				$self.css({
					'top': value+'px'
				});
			}
		};

		$( window ).scroll(function() {
			$('.parallax-content').headerSmallParallax();
		});

	}
});